import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  dropdownLookup,
  selectOTPMethod,
  submitForm,
  submitOTP,
  getPrepop,
  updateCapacity,
} from "./API";

export const getDropdownData = createAsyncThunk(
  "vd/getDropdownData",
  async (_, { getState, rejectWithValue, fulfillWithValue }) => {
    return dropdownLookup()
      .then((res) => fulfillWithValue(res))
      .catch((e) => rejectWithValue(e));
  }
);

export const updateCapacityAsync = createAsyncThunk(
  "vd/updateCapacity",
  async (_, { getState, rejectWithValue, fulfillWithValue }) => {
    return updateCapacity(getState().vd.formState.values)
      .then((res) => fulfillWithValue(res))
      .catch((e) => rejectWithValue(e));
  }
);

export const submitFormAsync = createAsyncThunk(
  "vd/SubmitForm",
  async (_,{ getState, rejectWithValue, fulfillWithValue }) => {
    return submitForm(getState().vd.formState.values)
      .then((res) => fulfillWithValue(res))
      .catch((e) => rejectWithValue(e));
  }
);

export const getPrepopDataAsync = createAsyncThunk(
  "vd/prepop",
  async (token, { getState, rejectWithValue, fulfillWithValue }) => {
    return getPrepop(token)
      .then((res) => fulfillWithValue(res))
      .catch((e) => rejectWithValue(e));
  }
);

export const selectOTPMethodAsync = createAsyncThunk(
  "vd/selectOTP",
  async (method, { rejectWithValue, fulfillWithValue }) => {
    return selectOTPMethod(method)
      .then((res) => fulfillWithValue(res))
      .catch((e) => rejectWithValue(e));
  }
);

export const submitOTPAsync = createAsyncThunk(
  "vd/submitOTP",
  async (otp, { rejectWithValue, fulfillWithValue }) => {
    return submitOTP(otp)
      .then((res) => fulfillWithValue(res))
      .catch((e) => rejectWithValue(e));
  }
);

export const appSlice = createSlice({
  name: "vd",
  initialState: {
    loading: false,
    isKiosk: false,
    isScanner: false,
    errors: null,
    page: 0,
    dropdownsloading: false,
    dropdownoptions: [],
    prepopData: false
  },
  reducers: {
    updateFormState: (state, action) => {
      state.formState = action.payload;
    },
    cancel: (state) => {
      //Preserve fromData: state.page = 0;
      state.loading = false;
      state.errors = null;
      state.page = 0;
    },
    clearErrors: (state) => {
      state.errors = null;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    cancelVerification: (state) => {
      state.loading = false;
      state.errors = null;
      state.page = 0;
      state.prepopData = false;
      if (!state.isKiosk) state.formState = null;
    },
    getCapacity: (state, action) => {
      state.loading = false;
      state.errors = null;
      if (!state.prepopData) {
        state.page = 1;
        // state.formState = action.payload;
      } else {
        updateCapacityAsync();
      }
    },
    timeout: (state) => {
      if (!state.loading || !state.errors) {
        state.loading = false;
        state.errors = {
          errortitle: "Verification OTP Timed out",
          error: "The OTP has expired, please try to again",
        };
        state.page = 0;
        state.formState = null;
      }
    },
  },
  extraReducers: {
    [submitFormAsync.pending]: (state) => {
      state.status = "loading";
      state.loading = true;
    },
    [submitFormAsync.fulfilled]: (state, action) => {
      state.status = "idle";
      state.loading = false;

      state.errors = null;
      if (action.payload.timeLineData) {
        state.timeline = action.payload.timeLineData;
        state.message = action.payload.message;
        state.page = 4;
      } else {
        state.page = 2;
        state.otpMethods = action.payload.otpmethods;
      }
    },
    [submitFormAsync.rejected]: (state, action) => {
      state.status = "idle";
      state.loading = false;
      state.errors = action.payload;
      state.otpMethods = null;
      state.page = 0;
      state.formState = null;
    },

    //Select OTP Method Promise Cases
    [selectOTPMethodAsync.pending]: (state, action) => {
      state.status = "loading";
      state.loading = true;
    },
    [selectOTPMethodAsync.fulfilled]: (state, action) => {
      state.status = "idle";
      state.loading = false;
      state.errors = null;
      state.selectedOTPMethod = action.payload;
      state.page = 3;
    },
    [selectOTPMethodAsync.rejected]: (state, action) => {
      state.status = "idle";
      state.loading = false;
      state.errors = action.payload;
      state.otpMethods = null;
    },

    //Submit OTP Promise Cases
    [submitOTPAsync.pending]: (state, action) => {
      state.status = "loading";
      state.loading = true;
    },

    [submitOTPAsync.fulfilled]: (state, action) => {
      state.status = "idle";
      state.loading = false;
      state.errors = null;
      state.timeline = action.payload.timeLineData;
      state.message = action.payload.message;
      state.page = 4;
    },
    [submitOTPAsync.rejected]: (state, action) => {
      state.status = "idle";
      state.loading = false;
      state.errors = action.payload;
      state.otpMethods = null;
    },

    [getDropdownData.pending]: (state) => {
      state.dropdownsloading = true;
    },

    [getDropdownData.fulfilled]: (state, action) => {
      state.dropdownsloading = false;
      state.dropdownoptions = action.payload;
    },
    [getDropdownData.rejected]: (state, action) => {
      state.dropdownsloading = false;
      state.errors = action.payload;
    },
    [getPrepopDataAsync.pending]: (state, action) => {
      state.status = "loading";
      state.loading = true;
    },
    [getPrepopDataAsync.fulfilled]: (state, action) => {
      state.status = "idle";
      state.loading = false;
      state.errors = null;
      state.prepopData = false;
      if (action.payload.timeLineData) {
        state.timeline = action.payload.timeLineData;
        state.message = action.payload.message;
        state.formState = { values: action.payload.retFormData };
        state.page = 4;
      }
      if (action.payload.IDNumber !== null && action.payload.IDNumber !== undefined) {
        state.prepopData = true;
        state.formState = { values: action.payload };
        state.page = 0;
      }
    },
    [getPrepopDataAsync.rejected]: (state, action) => {
      state.status = "idle";
      state.loading = false;
      state.errors = action.payload;
      state.timeline = null;
      state.message = null;
      state.page = 0;
    },    
    [updateCapacityAsync.pending]: (state) => {
      state.status = "loading";
      state.loading = true;
    },
    [updateCapacityAsync.fulfilled]: (state, action) => {
      state.status = "idle";
      state.loading = false;
      state.formState = { values: action.payload };
      state.page = 1;
    },
    [updateCapacityAsync.rejected]: (state, action) => {
      state.status = "idle";
      state.loading = false;
      state.errors = action.payload;
      state.otpMethods = null;
    },
  },
});

export const {
  updateFormState,
  cancel,
  clearErrors,
  cancelVerification,
  timeout,
  setPage,
  getCapacity
} = appSlice.actions;

export const isLoading = (state) => state?.vd?.loading;
export const isPrepop = (state) => state?.vd?.prepopData;
export const isKiosk = (state) => state?.vd?.isKiosk;
export const isScanner = (state) => state?.vd?.scanner;
export const timelineData = (state) => state?.vd?.timeline;
export const formState = (state) => state?.vd?.formState;
export const errors = (state) => state?.vd?.errors;
export const otpMethods = (state) => state?.vd?.otpMethods;
export const selectedOTPMethod = (state) => state?.vd?.selectedOTPMethod;
export const currentPage = (state) => state?.vd?.page;
export const selectedcapacity = (state) =>   state?.vd?.formState?.values.Capacity;
export const selectedtaxyear = (state) => state?.vd?.formState?.values.TaxYear;
export const dropdownoptions = (state) => state?.vd?.dropdownoptions;
export const dropdownsloading = (state) => state?.vd?.dropdownsloading;
export default appSlice.reducer;
